/**
 * A fully transparent colour, as the colour picker writes one.
 *
 * **Declared here rather than imported from `@components/sp-color-picker`.** The shipped button
 * presets need it for a contour that is not drawn, and they are pure data — reaching into an
 * Angular component library for one string made them unreachable from `apps/mcp-backend`, which
 * applies a preset on an AI call.
 *
 * Must stay byte-identical to that library's `TRANSPARENT_VALUE`: the picker compares the stored
 * string against it to decide whether to show its transparency swatch as selected, and a value that
 * differs only in whitespace reads as an ordinary colour there.
 */
export const TRANSPARENT_COLOR = 'rgba(255, 255, 255, 0)';
